module.exports = __webpack_public_path__ + "static/tweet-b287b46ecc9d402e78e3af17fa57d939.png";